import { ModuleConfig } from "/@/cool";

export default (): ModuleConfig => {
	return {
		views: [
			{
				path: "/package/order",
				component: () => import("./views/package-order.vue"),
				meta: {
					label: "套餐下单",
					lang_key: "package_order"
				}
			},
			{
				path: "/package/test-flow",
				component: () => import("./views/test-flow.vue"),
				meta: {
					label: "流程测试"
				}
			},
			{
				path: "/package/shop-view-settle",
				component: () => import("./views/shop-view-settle.vue"),
				meta: {
					label: "门店套餐结算",
					lang_key: "package_shop_view_settle"
				}
			}
		],
		async onLoad() {
			return {};
		}
	};
};
